module.exports = __webpack_public_path__ + "img/cat-03.2c59d33d.png";